import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
// import { ApiService } from '../../../api/userApi/api.service';
import { ApiService } from '../../../api.service';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { BookType } from 'xlsx/types';

@Component({
  selector: 'app-admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrls: ['./admin-sidebar.component.css']
})
export class AdminSidebarComponent implements OnInit {
  expanded: boolean = true;
  expand: boolean = true;
  expand1: boolean = true;
  expand2: boolean = true;
  expand3: boolean = true;
  expand4: boolean = true;
  expand5: boolean = true;
  expand6: boolean = true;
  expand7: boolean = true;
  expand8: boolean = true;
  expand9 : boolean = true;

  menu_slider: boolean = true;
  login_Details:any;
  Dashboard_show  = false;
  clienttype_show = false;
  portfolio_show = false;
  product_show = false;
  clientmanagement_show = false;
  clienstatusmaking_show = false;
  usertypecreate_show = false;
  userrol_show = false
  usergroup_show = false;
  usermanagemnt_show = false;
  userstautsamking_show = false;
  portfolioinbox_show = false;
  notificationinbox_show = false;
  customer_show = false;
  configurationsscreen_show = false;
  documents_type_show = false;
  productmaping_show = false;
  bucket_mang_show = false;
  table_field_show = false;
  account_type_show = false;
  desingation_show = false;
  country_currency_show = false;
  state_show = false;
  predefined_filed_show = false;
  organization_mag_show = false;

  allocation_show = false;
  reallocation_show = false;
  re_allocations = false;
  work_list_show = false;
  field_visit_approval_request = false;
  field_visit_agent_approval_request = false;
  settlement_approval_request = false;

  portfolio_bucket_show = false;
  allocation1_show = false;
  excel_upload = false;
  Globle_Search = false;
  Report_for_Agent = false;
  Report_for_Team_Head = false;






  Mennu2_show = false;
  Mennu3_show = false;
  Mennu4_show = false;
  Mennu5_show = false;
  Mennu6_show = false;
  Mennu7_show = false;
  Mennu8_show = true;
  Mennu9_show = false;
  Mennu10_show: boolean;
  Works_show: boolean;
  Worklist_show: boolean;
  Allocation_show: boolean;
  Re_Allocation_show: boolean;
  Team_Allocation_show: boolean;
  To_Do_List_show: boolean;
  Master_Data_show: boolean;
  Master_show: boolean;
  Excel_Upload_show: boolean;
  Approvals_show: boolean;
  Master_reports_show: boolean;


  constructor(
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private router: Router,
    private _api: ApiService,
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
   this.login_Details = this.getFromLocal("login_Details");

    // console.log(this.login_Details.access);

      

    // var checkAccess = JSON.parse(this.login_Details.access);
    var checkAccess = this.login_Details.access;
   for(let a  = 0 ; a < checkAccess.length; a ++){

    //  var temptitle = JSON.parse(this.login_Details.access)[a];
    var temptitle = this.login_Details.access[a];
        if(temptitle.title  == 'Dashboard' && temptitle.Status ==  true){
          this.Dashboard_show = true;
        }

        if(temptitle.title  == 'Works' && temptitle.Status ==  true){
          this.Works_show = true;
        }


        if(temptitle.title  == 'Worklist' && temptitle.Status ==  true){
          this.Worklist_show = true;
        }


        if(temptitle.title  == 'Allocation' && temptitle.Status ==  true){
          this.Allocation_show = true;
        }


        if(temptitle.title  == 'Re-Allocation' && temptitle.Status ==  true){
          this.Re_Allocation_show = true;
        }


        if(temptitle.title  == 'Team Allocation' && temptitle.Status ==  true){
          this.Team_Allocation_show = true;
        }

        if(temptitle.title  == 'To-Do List' && temptitle.Status ==  true){
          this.To_Do_List_show = true;
        }

        if(temptitle.title  == 'Master Data' && temptitle.Status ==  true){
          this.Master_Data_show = true;
        }


        if(temptitle.title  == 'Master' && temptitle.Status ==  true){
          this.Master_show = true;
        }


        if(temptitle.title  == 'Excel Upload' && temptitle.Status ==  true){
          this.Excel_Upload_show = true;
        }


        if(temptitle.title  == 'Approvals' && temptitle.Status ==  true){
          this.Approvals_show = true;
          this.notificationinbox_show = true;
        }


        if(temptitle.title  == 'Field Visit Approval Agent' && temptitle.Status ==  true){
          this.field_visit_agent_approval_request = true;
        }


        if(temptitle.title  == 'Field Visit Approval Coordinator' && temptitle.Status ==  true){
          this.field_visit_approval_request = true;
        }


        if(temptitle.title  == 'Settlement Approval' && temptitle.Status ==  true){
          this.settlement_approval_request = true;
        }


        if(temptitle.title  == 'Master Reports' && temptitle.Status ==  true){
          this.Master_reports_show = true;
        }

        if(temptitle.title  == 'Globle Search' && temptitle.Status ==  true){
          this.Globle_Search = true;
        }

        if(temptitle.title  == 'Report for Agent' && temptitle.Status ==  true){
          this.Report_for_Agent = true;
        }

        if(temptitle.title  == 'Report for Team Head' && temptitle.Status ==  true){
          this.Report_for_Team_Head = true;
        }



   }





  }
  formtype() {
    this.saveInLocal('Company_detail', undefined);
    this.saveInLocal('Form_type', 'create');
  }


  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }
  menuslide() {
    this.menu_slider = !this.menu_slider;
  }
  act() {
    this.expand1 = true;
    this.expand2 = true;
    this.expand3 = true;
    this.expand4 = true;
    this.expand5 = true;
    this.expand6 = true;
    this.expand7 = true;
    this.expand8 = true;
  }
  act1() {
    this.expand1 = false;
    this.expand2 = true;
    this.expand3 = true;
    this.expand4 = true;
    this.expand5 = true;
    this.expand6 = true;
    this.expand7 = true;
    this.expand8 = true;
  }
  act2() {
    this.expand2 = false;
    this.expand1 = true;
    this.expand3 = true;
    this.expand4 = true;
    this.expand5 = true;
    this.expand6 = true;
    this.expand7 = true;
    this.expand8 = true;
  }
  act3() {
    this.expand3 = false;
    this.expand2 = true;
    this.expand1 = true;
    this.expand4 = true;
    this.expand5 = true;
    this.expand6 = true;
    this.expand7 = true;
    this.expand8 = true;
  }
  act4() {
    this.expand4 = false;
    this.expand2 = true;
    this.expand3 = true;
    this.expand1 = true;
    this.expand5 = true;
    this.expand6 = true;
    this.expand7 = true;
    this.expand8 = true;
  }
  act5() {
    this.expand5 = false;
    this.expand2 = true;
    this.expand3 = true;
    this.expand4 = true;
    this.expand1 = true;
    this.expand6 = true;
    this.expand7 = true;
    this.expand8 = true;
  }
  act6() {
    this.expand6 = false;
    this.expand2 = true;
    this.expand3 = true;
    this.expand4 = true;
    this.expand5 = true;
    this.expand1 = true;
    this.expand7 = true;
    this.expand8 = true;
  }
  act7() {
    this.expand7 = false;
    this.expand2 = true;
    this.expand3 = true;
    this.expand4 = true;
    this.expand5 = true;
    this.expand6 = true;
    this.expand1 = true;
    this.expand8 = true;
  }
  act8() {
    this.expand8 = false;
    this.expand2 = true;
    this.expand3 = true;
    this.expand4 = true;
    this.expand5 = true;
    this.expand6 = true;
    this.expand7 = true;
    this.expand1 = true;
  }
  logout(){
    this.storage.clear();
    this.router.navigate(['']);
  }
  onActivate(event) {
    window.scroll(0,0);
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)

}
}
